module.exports = __webpack_public_path__ + "static/media/menu_02.e7e406d3.jpg";